import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import Classes from "./Classes";
import { default_data, default_object } from "./data";

export const projectsInfoGenerator = (obj) => {
  if (obj && obj.root && obj.root.LWongWeb && obj.root.LWongWeb.PROJECTS) {
    const projects = obj.root.LWongWeb.PROJECTS;
    const base = { classes: [] };
    for (const project in projects) {
      const projectClass = {
        class: project,
        index: projects[project].index,
        projects: [],
      };

      if (projects[project].id !== undefined || typeof projects[project] === "object") {
        const inner = projects[project];
        for (const property in inner) {
          if (
            property !== "id" &&
            property !== "name" &&
            property !== "images" &&
            property !== "index" &&
            typeof inner[property] === "object" &&
            inner[property] !== null
          ) {
            const innerObject = {
              name: inner[property].name || property,
              id: inner[property].id || property,
              listInfo: inner[property].listInfo || [],
              index: inner[property].index || 0,
              details: [
                {
                  title: inner[property].title1 || "",
                  text: inner[property].text1 || "",
                },
                {
                  title: inner[property].title2 || "",
                  text: inner[property].text2 || "",
                },
                {
                  title: inner[property].title3 || "",
                  text: inner[property].text3 || "",
                },
              ],
            };
            const photos = [];
            if (inner[property].images && Array.isArray(inner[property].images)) {
              inner[property].images.forEach((url) => {
                photos.push({
                  src: url,
                  width: 1.5,
                  height: 1,
                });
              });
            }
            innerObject["photos"] = photos;
            projectClass.projects.push(innerObject);
          }
        }
        projectClass.projects.sort((a, b) => (Number(a.index) || 0) - (Number(b.index) || 0));
        base.classes.push(projectClass);
      }
    }
    base.classes.sort((a, b) => (Number(a.index) || 0) - (Number(b.index) || 0));
    return base;
  }
  return default_data;
};

let liveObjectCache = null;

function Receiver(props) {
  const [user] = useState("bhzfBvdgxZYrvKvDaXz5iaQzIjn1");
  const [, setObject] = useState(() => liveObjectCache || default_object);
  const [data, setData] = useState(() => projectsInfoGenerator(liveObjectCache || default_object));

  const applyLiveDraft = (summaryKey, docData) => {
    setObject((prevObject) => {
      const nextObj = JSON.parse(JSON.stringify(prevObject || liveObjectCache || default_object));
      const pathArray = summaryKey.split("/").filter(Boolean);
      let base = nextObj;
      for (let i = 0; i < pathArray.length; i++) {
        if (i === pathArray.length - 1) {
          base[pathArray[i]] = Object.assign(base[pathArray[i]] || {}, docData);
        } else {
          base = base[pathArray[i]] = base[pathArray[i]] || {};
        }
      }
      liveObjectCache = nextObj;
      setData(projectsInfoGenerator(nextObj));
      return nextObj;
    });
  };

  useEffect(() => {
    let bc;
    try {
      bc = new BroadcastChannel("lwong_live_preview");
      bc.onmessage = (event) => {
        if (event.data && event.data.type === "LIVE_UPDATE") {
          applyLiveDraft(event.data.summaryKey, event.data.docData);
        }
      };
    } catch (e) {}

    const handleMessage = (event) => {
      if (event.data && event.data.type === "LIVE_UPDATE") {
        applyLiveDraft(event.data.summaryKey, event.data.docData);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      if (bc) bc.close();
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (user) {
      const docRef = doc(db, "trees", "users", user, "summary");
      const unsub = onSnapshot(
        docRef,
        (docSnap) => {
          if (docSnap.exists()) {
            const rawData = docSnap.data();
            const pathFilter = `trees/users/${user}/`;
            const cleaned = {};
            for (const prop in rawData) {
              const shortDir = prop.replace(pathFilter, "");
              cleaned[shortDir] = rawData[prop];
            }

            const newObject = {};
            for (const prop in cleaned) {
              const pathArray = prop.split("/").filter(Boolean);
              let base = newObject;
              for (let i = 0; i < pathArray.length; i++) {
                if (i === pathArray.length - 1) {
                  base[pathArray[i]] = Object.assign(base[pathArray[i]] || {}, cleaned[prop]);
                } else {
                  base = base[pathArray[i]] = base[pathArray[i]] || {};
                }
              }
            }
            liveObjectCache = newObject;
            setObject(newObject);
            setData(projectsInfoGenerator(newObject));
          }
        },
        (error) => {
          console.warn("Firestore summary snapshot warning:", error);
        }
      );
      return () => unsub();
    }
  }, [user]);

  return <Classes dispId={props.dispId} data={data} navbar={props.navbar} />;
}

export default Receiver;
